// ── Openingstijden ───────────────────────────────────────
// Bron: https://vitaal-sterk.nl/contact/ (tabel "Openingstijden") — bij wijzigingen
// op de website dit bestand ook bijwerken. Index 0 = maandag, 6 = zondag.
export const OPENINGSTIJDEN = [
  { open: '07:00', sluit: '21:00' }, // maandag
  { open: '08:00', sluit: '12:00', open2: '16:00', sluit2: '20:30' }, // dinsdag
  { open: '07:00', sluit: '12:00', open2: '16:00', sluit2: '21:00' }, // woensdag
  { open: '08:00', sluit: '12:00', open2: '16:00', sluit2: '20:30' }, // donderdag
  { open: '07:00', sluit: '18:00' }, // vrijdag
  { open: '08:00', sluit: '12:00' }, // zaterdag
  { open: '09:00', sluit: '13:00' }, // zondag
]

function huidigeDagIndex() {
  const dag = new Date().getDay()
  return dag === 0 ? 6 : dag - 1
}

export function isNuOpen() {
  const nu = new Date()
  const tijden = OPENINGSTIJDEN[huidigeDagIndex()]
  const uur = nu.getHours() + nu.getMinutes() / 60
  const [oh, om] = tijden.open.split(':').map(Number)
  const [sh, sm] = tijden.sluit.split(':').map(Number)
  const openTijd = oh + om / 60
  const sluitTijd = sh + sm / 60
  if (uur >= openTijd && uur < sluitTijd) return true
  if (tijden.open2) {
    const [oh2, om2] = tijden.open2.split(':').map(Number)
    const [sh2, sm2] = tijden.sluit2.split(':').map(Number)
    if (uur >= (oh2 + om2 / 60) && uur < (sh2 + sm2 / 60)) return true
  }
  return false
}

// Geeft de openingsblokken van vandaag terug als hele uren, bv. voor een
// dinsdag: [[8,9,10,11], [16,17,18,19,20]]. Een blok van 20:30 telt het hele
// 20-uur-blok nog mee; een blok tot een heel uur (bv. 12:00) niet meer.
export function vandaagUrenBlokken() {
  const tijden = OPENINGSTIJDEN[huidigeDagIndex()]
  const blokken = [[tijden.open, tijden.sluit]]
  if (tijden.open2) blokken.push([tijden.open2, tijden.sluit2])
  return blokken.map(([open, sluit]) => {
    const [oh] = open.split(':').map(Number)
    const [sh, sm] = sluit.split(':').map(Number)
    const eindUur = sm > 0 ? sh : sh - 1
    const uren = []
    for (let u = oh; u <= eindUur; u++) uren.push(u)
    return uren
  })
}

function dagEersteUur(tijden) {
  const [oh] = tijden.open.split(':').map(Number)
  return oh
}

function dagEindUur(tijden) {
  const [sh, sm] = (tijden.open2 ? tijden.sluit2 : tijden.sluit).split(':').map(Number)
  return sm > 0 ? sh : sh - 1
}

// Het laatste sluitingsuur dat ooit voorkomt (nu 20u, op maandag/woensdag) —
// gebruikt als vaste rechtergrens voor de as van elke dag, zodat de
// 'gesloten'-periode ná sluitingstijd zichtbaar blijft.
function globaalEindUur() {
  return Math.max(...OPENINGSTIJDEN.map(dagEindUur))
}

// Het grootste aantal uur-slots dat de as van een dag ooit beslaat (van het
// eigen openingsuur t/m de vaste rechtergrens hierboven). Gebruikt om de
// balkjesbreedte in het drukte-blokje elke dag gelijk te houden, ook al toont
// een dag met een latere opening (bv. zaterdag) minder balkjes.
export function maxUrenPerDag() {
  const eind = globaalEindUur()
  return Math.max(...OPENINGSTIJDEN.map(t => eind - dagEersteUur(t) + 1))
}

// Geeft de volledige uren-as van vandaag terug — van het eigen openingsuur van
// vandaag t/m de vaste rechtergrens, met per uur of het daadwerkelijk open is.
// Zo begint de as nooit vóór openingstijd (dat was verwarrend), maar blijft de
// 'gesloten'-periode na sluitingstijd (en een eventueel tussenliggend gat,
// zoals de lunchpauze op di/wo/do) gewoon zichtbaar zoals voorheen.
export function vandaagUrenAs() {
  const tijden = OPENINGSTIJDEN[huidigeDagIndex()]
  const openUren = new Set(vandaagUrenBlokken().flat())
  const eerste = dagEersteUur(tijden)
  const eind = globaalEindUur()
  const uren = []
  for (let u = eerste; u <= eind; u++) uren.push(u)
  return uren.map(uur => ({ uur, open: openUren.has(uur) }))
}

// De echte sluitingstijd van vandaag (laatste dienst), als 'HH:MM'-string.
// Gebruikt voor het sluitingslabel op de as — daar waar een uur-balkje soms
// afrondt (een blok tot 20:30 telt het hele 20-uur-blok nog mee), is dit altijd
// de exacte sluitingstijd, bv. "20:30" op dinsdag/donderdag i.p.v. een afgerond "21u".
export function vandaagSluitingstijd() {
  const tijden = OPENINGSTIJDEN[huidigeDagIndex()]
  return tijden.open2 ? tijden.sluit2 : tijden.sluit
}

// ── Half-uur variant ─────────────────────────────────────
// Zelfde opzet als vandaagUrenAs(), maar dan per half uur (bv. Milon-training
// duurt 35 minuten, dus per-uur was te grof). Elk blok is het HH:MM-startpunt
// van dat half uur, bv. "18:30" loopt van 18:30 t/m 18:59.

function tijdNaarMinuten(t) {
  const [h, m] = t.split(':').map(Number)
  return h * 60 + m
}

function minutenNaarBlok(min) {
  const h = Math.floor(min / 60)
  const m = min % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

// Openingsblokken van vandaag als half-uur-startpunten, bv. dinsdag:
// [["08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30"],
//  ["16:00", ..., "20:00"]] — een blok tot 20:30 sluit het 20:00-blok nog in,
// een blok tot een heel uur (12:00) niet meer.
export function vandaagHalfUurBlokken() {
  const tijden = OPENINGSTIJDEN[huidigeDagIndex()]
  const blokken = [[tijden.open, tijden.sluit]]
  if (tijden.open2) blokken.push([tijden.open2, tijden.sluit2])
  return blokken.map(([open, sluit]) => {
    const startMin = tijdNaarMinuten(open)
    const eindMin = tijdNaarMinuten(sluit)
    const result = []
    for (let m = startMin; m < eindMin; m += 30) result.push(minutenNaarBlok(m))
    return result
  })
}

function dagEersteHalfUur(tijden) {
  return tijdNaarMinuten(tijden.open)
}

function dagEindHalfUur(tijden) {
  const sluit = tijden.open2 ? tijden.sluit2 : tijden.sluit
  const eindMin = tijdNaarMinuten(sluit)
  // Laatste blok vóór sluitingstijd (een sluiting op een heel half uur, bv.
  // 12:00, telt het 11:30-blok nog als laatste; 20:30 telt zichzelf nog mee).
  return eindMin % 30 === 0 ? eindMin - 30 : eindMin - (eindMin % 30)
}

function globaalEindHalfUur() {
  return Math.max(...OPENINGSTIJDEN.map(dagEindHalfUur))
}

// Het grootste aantal half-uur-slots dat de as van een dag ooit beslaat —
// zelfde doel als maxUrenPerDag(), maar dan per half uur.
export function maxHalfUrenPerDag() {
  const eind = globaalEindHalfUur()
  return Math.max(...OPENINGSTIJDEN.map(t => Math.round((eind - dagEersteHalfUur(t)) / 30) + 1))
}

// Volledige half-uur-as van vandaag: van het eigen openingshalfuur van vandaag
// t/m de vaste rechtergrens, met per blok of het daadwerkelijk open is.
export function vandaagHalfUurAs() {
  const tijden = OPENINGSTIJDEN[huidigeDagIndex()]
  const openBlokken = new Set(vandaagHalfUurBlokken().flat())
  const eerste = dagEersteHalfUur(tijden)
  const eind = globaalEindHalfUur()
  const blokken = []
  for (let m = eerste; m <= eind; m += 30) blokken.push(minutenNaarBlok(m))
  return blokken.map(blok => ({ blok, open: openBlokken.has(blok) }))
}
